import React from "react";
import { Link, useParams } from "react-router-dom";
import MetaData from "../layout/MetaData";
import AdminLayout from "../layout/AdminLayout";
import { useOrderDetailsQuery } from "../../redux/api/bookingApi";
import "../../css/Admin.css";

const ProcessOrder = () => {
  const params = useParams();
  const { data } = useOrderDetailsQuery(params?.id);
  const order = data?.order || {};

  const { userAddressInfo, googleMap, labour, goodsInfo, totalAmount, orderStatus } = order;

  const Row = ({ label, value }) => (
    <tr>
      <th scope="row">{label}</th>
      <td>{value || "—"}</td>
    </tr>
  );

  return (
    <AdminLayout>
      <MetaData title="Process Order" />
      <div className="row d-flex justify-content-around">
        <div className="col-12 col-lg-9 order-details">

          <h3 className="mt-4 mb-3">Pricing</h3>
          <div className="card mb-4">
            <table className="table mb-0">
              <tbody>
                <Row label="Proposed Amount By User" value={`${goodsInfo?.userProposedAmount} PKR`} />
                <Row
                  label="Proposed Amount By Driver"
                  value={order?.adminProposedAmount ? `${order.adminProposedAmount} PKR` : "No Proposed Amount Given by Driver"}
                />
                <Row label="Total Amount" value={`${totalAmount} PKR`} />
              </tbody>
            </table>
          </div>

          <h3 className="mb-3">Ride Details</h3>
          <div className="card mb-4">
            <table className="table mb-0">
              <tbody>
                <Row label="ID" value={order?._id} />
                <tr>
                  <th scope="row">Ride Status</th>
                  <td className={String(orderStatus).includes("Delivered") ? "greenColor" : "redColor"}>
                    <b>{orderStatus}</b>
                  </td>
                </tr>
                <Row label="Booking Type" value={userAddressInfo?.bookingType} />
                <Row label="Load Type" value={userAddressInfo?.loadType} />
                <Row label="Distance" value={<b>{googleMap?.distance}</b>} />
                <Row label="Vehicle Needed" value={userAddressInfo?.vehicle} />
              </tbody>
            </table>
          </div>

          <h3 className="mb-3">Goods Info</h3>
          <div className="card mb-4">
            <table className="table mb-0">
              <tbody>
                <Row label="Type Of Goods" value={goodsInfo?.goodsType} />
                <Row label="Total Weight" value={`${goodsInfo?.totalWeight} KG`} />
                <Row label="Volume" value={`${goodsInfo?.volume} m³`} />
                <Row label="Load Type" value={goodsInfo?.loadingType} />
              </tbody>
            </table>
          </div>

          <h3 className="mb-3">Route Details</h3>
          <div className="card mb-4">
            <table className="table mb-0">
              <tbody>
                <Row label="Starting Address" value={googleMap?.origin} />
                <Row label="Destination Address" value={googleMap?.destination} />
                <Row label="Distance" value={googleMap?.distance} />
              </tbody>
            </table>
          </div>

          <h3 className="mb-3">Contact Info</h3>
          <div className="card mb-4">
            <table className="table mb-0">
              <tbody>
                <Row label="Phone No" value={`0${order?.phoneNo}`} />
                <tr>
                  <th scope="row">WhatsApp</th>
                  <td>
                    <Link
                      className="btn btn-success btn-sm"
                      target="_blank"
                      to={`https://api.whatsapp.com/send?phone=92${order?.phoneNo}`}
                      rel="noreferrer"
                    >
                      <i className="bi bi-whatsapp" /> Open WhatsApp
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 className="mb-3">Labour Detail</h3>
          <div className="card mb-4">
            <table className="table mb-0">
              <tbody>
                <Row label="Labours at start address" value={labour?.noOfLaboursStart || 0} />
                <Row label="Labours at destination address" value={labour?.noOfLaboursDestination || 0} />
                <Row label="Floors at start address" value={labour?.buildingFloorsStart || 0} />
                <Row label="Floors at destination address" value={labour?.buildingFloorsDestination || 0} />
                <Row label="Cargo Lift at start address" value={labour?.cargoLiftStart ? "Yes" : "No"} />
                <Row label="Cargo Lift at destination address" value={labour?.cargoLiftDestination ? "Yes" : "No"} />
              </tbody>
            </table>
          </div>

          <br />
          <br />
          <br />
        </div>
      </div>
    </AdminLayout>
  );
};

export default ProcessOrder;